import { createSeniorFlowTab } from './seniorFlowTabFactory';
import { registerTab } from './tabRegistry';

// senior_level_flow — "Shortlisted" tab (shown to the TA as "Shortlisted",
// per the flow-statuses API's own tabs[].name — a real GET response
// confirms this is its own separate, terminal (is_final: true) state, not
// merged into "Completed"/"Final Call" as an earlier sample suggested; see
// SeniorCompletedTab.jsx. manual_actions is empty — this state is reached
// automatically (auto_actions: create_screened_mapping,
// notify_cse_new_candidate_sourced), never by a manual transition — so
// there is no row action to resolve here beyond the shared "View profile".
//
// The reference design for this tab (screening-pipeline-v6.html's
// "Shortlisted") shows an interview score, a pool rank and a submission
// (submitted/pending, to whom) status — none of that is backed by real
// data: a live candidates-pipeline response for a Shortlisted-status
// candidate is just the standard candidate row (name, email, phone,
// mapped_at, job_title/org, experience, notice_period) with no score, rank
// or submission fields at all. Built on the same plain factory shell every
// other senior_level_flow tab uses instead of inventing columns with
// nothing behind them, per explicit instruction.
const SeniorShortlistedTab = createSeniorFlowTab(
  'Shortlisted',
  'No candidates have been shortlisted yet.'
);

registerTab({
  stateMachineKey: 'senior_level_flow',
  state: 'Shortlisted',
  component: SeniorShortlistedTab,
});

export default SeniorShortlistedTab;
